<template>
  <div>
    <!-- a bootstrap badge styled as button -->
    <button
      type="button"
      :class="requestCssClass"
      :disabled="requestPaidStatus"
      @click="modal.show()"
    >
      {{ requestBtnTxt }}
    </button>

    <!-- Modal -->
    <div
      :id="modalId"
      ref="modal"
      class="modal"
      tabindex="-1"
      aria-labelledby="paymentRequestModal"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-lg">
        <div class="modal-content">
          <div class="modal-header">
            <h1
              id="paymentRequestModalLabel"
              class="modal-title fs-5"
            >
              Payment Request
            </h1>
          </div>
          <form
            :id="`payment-request-form-${assignmentId}`"
            ref="form"
            type="multipart/form-data"
            class="mb-3"
            method="post"
            action="#"
            @submit="checkForm"
          >
            <div class="modal-body">
              <!-- request payment form -->
              <div
                v-if="errors.length"
                class="mb-3"
              >
                <b>Please correct the following error(s):</b>
                <ul>
                  <li
                    v-for="(error, i) in errors"
                    :key="i.toString()"
                    class="text-danger"
                  >
                    {{ fieldErrors[error] }}
                  </li>
                </ul>
              </div>

              <div class="mb-3">
                <div class="form-check form-switch">
                  <input
                    id="isHeadHunting"
                    v-model="isHeadHunting"
                    name="is_head_hunting"
                    class="form-check-input"
                    type="checkbox"
                    role="switch"
                  >
                  <label
                    class="form-check-label"
                    for="isHeadHunting"
                  > Is this a candidate successfully placed for headhunting?</label>
                </div>
              </div>

              <div v-if="isHeadHunting">
                <div class="mb-3">
                  <label
                    for="credits"
                    class="col-form-label"
                  >Credits:</label>
                  <input
                    id="credits"
                    v-model="credits"
                    v-no-wheel
                    name="credits"
                    type="number"
                    class="form-control"
                    required
                  >
                </div>
              </div>
              <div v-else>
                <div class="card mb-3">
                  <div class="card-header">
                    <strong>Expert Payment</strong>
                  </div>
                  <div class="card-body">
                    <div class="mb-3">
                      <label
                        for="consultation-duration"
                        class="col-form-label"
                      >Consultation Duration
                        (Minutes):</label>
                      <input
                        id="consultation-duration"
                        v-model="consultationDuration"
                        v-no-wheel
                        name="duration"
                        type="number"
                        class="form-control"
                        required
                      >
                    </div>
                    <div class="mb-3">
                      <label
                        for="hourly-rate"
                        class="col-form-label"
                      >Hourly Rate (USD):</label>
                      <input
                        id="hourly-rate"
                        v-model="hourlyRate"
                        v-no-wheel
                        name="hourly_rate"
                        type="number"
                        class="form-control"
                        required
                      >
                    </div>
                  </div>
                </div>

                <div class="card mb-3">
                  <div class="card-header">
                    <strong>Client Reference</strong>
                  </div>
                  <div class="card-body">
                    <div class="mb-3">
                      <label
                        for="client-hourly-credit"
                        class="col-form-label"
                      >Hourly Credits to Charge Client:</label>
                      <input
                        id="client-hourly-credit"
                        v-model.number="clientHourlyCreditInput"
                        v-no-wheel
                        name="client_hourly_credit"
                        type="number"
                        step="any"
                        class="form-control"
                        required
                      >
                    </div>
                    <div class="mb-3">
                      <label
                        for="client-consultation-duration"
                        class="col-form-label"
                      >Client Consultation Duration (Minutes):</label>
                      <input
                        id="client-consultation-duration"
                        v-model="clientDuration"
                        v-no-wheel
                        name="client_duration"
                        type="number"
                        class="form-control"
                        required
                      >
                    </div>
                    <div class="mb-3">
                      <label
                        for="client-hourly-rate"
                        class="col-form-label"
                      >Client Hourly Rate:</label>
                      <input
                        id="client-hourly-rate"
                        v-model="clientHourlyRate"
                        v-no-wheel
                        name="client_hourly_rate"
                        type="number"
                        class="form-control"
                        required
                      >
                    </div>
                    <div class="mb-3">
                      <label
                        for="client-rate-currency"
                        class="col-form-label"
                      >Client Rate Currency:</label>
                      <select
                        id="client-rate-currency"
                        v-model="clientRateCurrency"
                        name="client_rate_currency"
                        class="form-select"
                        required
                      >
                        <option value="USD">
                          USD
                        </option>
                        <option value="EUR">
                          EUR
                        </option>
                        <option value="GBP">
                          GBP
                        </option>
                        <option value="CNY">
                          CNY
                        </option>
                      </select>
                    </div>
                  </div>
                </div>

                <!-- form radio input -->
                <div class="form-check">
                  <input
                    id="inHourCheck"
                    v-model="in48Hours"
                    name="in_hours"
                    class="form-check-input"
                    type="checkbox"
                  >
                  <label
                    class="form-check-label"
                    for="inHourCheck"
                  >
                    Is the consultation requested within 48 hours of project request?
                  </label>
                </div>

                <div class="form-check">
                  <input
                    id="followUpCheck"
                    v-model="followUp"
                    name="follow_up"
                    class="form-check-input"
                    type="checkbox"
                  >
                  <label
                    class="form-check-label"
                    for="followUpCheck"
                  >
                    Is the consultation a Follow Up?
                  </label>
                </div>
                <!-- upload image input -->
                <div
                  v-if="in48Hours"
                  id="staff-upload-form"
                >
                  <!-- description text div-->
                  <div
                    v-if="screenshots.length"
                    class="d-flex justify-content-center mb-3"
                  >
                    <div
                      v-for="(screenshot, idx) in screenshots"
                      :key="idx"
                      class="p-2"
                    >
                      <img
                        :src="screenshot"
                        class="img-fluid"
                      >
                    </div>
                  </div>

                  <span>Kindly attach screenshots showing the timestamps of:</span>
                  <!-- list of text -->
                  <ol class="list-group list-group-numbered">
                    <li class="list-group-item">
                      Project Received date and time
                    </li>
                    <li class="list-group-item">
                      Expert Requested date and time
                    </li>
                  </ol>
                  <div>
                    <label
                      for="formFile"
                      class="form-label"
                    >Upload screenshot</label>
                    <input
                      id="formFile"
                      ref="file"
                      name="images[]"
                      multiple
                      class="form-control"
                      type="file"
                      accept="image/*"
                    >
                  </div>
                </div>
              </div>

              <!--                Remark text box-->
              <div class="mb-3">
                <label for="floatingRemark">Remarks</label>
                <textarea
                  id="floatingRemark"
                  v-model="remarks"
                  class="form-control"
                  placeholder="Remarks"
                  name="remarks"
                  style="height: 100px"
                />
                <small>eg. Approved by Lynk?, Expert wants payment in the form of an Amazon voucher?,
                  etc.</small>
              </div>
            </div>

            <div class="modal-footer">
              <button
                :disabled="requesting"
                type="button"
                class="btn btn-secondary"
                data-bs-dismiss="modal"
              >
                Close
              </button>
              <button
                type="submit"
                class="btn btn-primary"
                :disabled="requesting"
              >
                Request
                <div
                  v-if="requesting"
                  class="spinner-border spinner-border-sm text-success"
                  role="status"
                >
                  <span class="visually-hidden">Loading...</span>
                </div>
              </button>
            </div>
            <payment-request-update-logs
              :request-logs="currentRequestLogs"
            />
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import includes from "lodash/includes";
import { Modal } from "bootstrap";
import moment from "moment-timezone";
import { isEmpty } from "lodash";

export default {
    name: "PaymentRequest",
    props: {
        staffUser: {
            type: Object,
            required: true,
        },
        expertUser: {
            type: Object,
            required: true,
        },
        project: {
            type: Object,
            required: true,
        },
        assignmentId: {
            type: Number,
            required: true,
        },
        assignmentStatuses: {
            type: [Object, Array],
            required: true,
            default: () => [],
        },
        currentStatus: {
            type: String,
            required: true,
        },
    },
    data: () => ({
        isHeadHunting: false,
        credits: null,
        consultationDuration: null,
        hourlyRate: null,
        requestRate: null,
        clientHourlyRate: null,
        clientDuration: null,
        clientRateCurrency: "USD",
        clientHourlyCredit: parseInt(1.00),
        in48Hours: false,
        followUp: false,
        errors: [],
        currentImage: null,
        remarks: "",
        screenshots: [],
        fieldErrors: {
            "consultation-duration": "Consultation duration is required",
            "hourly-rate": "Hourly rate is required",
            "client-consultation-duration": "Client consultation duration is required",
            "client-hourly-rate": "Client hourly rate is required",
            "credits": "Credits is required",
        },
        requesting: false,
    }),
    computed: {
        requestCssClass() {
            return {
                "btn": true,
                "btn-outline-primary": !this.requestSent,
                "btn-primary": this.requestSent,
                "btn-sm": true,
            };
        },
        modalId() {
            return `payment-request-modal-${this.expertUser.id}`;
        },
        modal() {
            const modal = new Modal(this.$refs.modal, { backdrop: "static", keyboard: false });

            document.getElementById(this.modalId).addEventListener("show.bs.modal", () => {
                const currentRequest = this.currentRequest;

                if (this.hasCurrentRequest) {
                    this.consultationDuration = currentRequest.duration;
                    this.isHeadHunting = currentRequest.head_hunting;
                    this.credits = currentRequest.credits;
                    this.hourlyRate = currentRequest.hourly_rate;
                    this.clientHourlyCredit = parseFloat(currentRequest.client_hourly_credit);
                    this.clientDuration = currentRequest.client_duration;
                    this.clientHourlyRate = currentRequest.client_hourly_rate;
                    this.clientRateCurrency = currentRequest.client_rate_currency ?? "USD";
                    this.in48Hours = currentRequest.in_hours;
                    this.followUp = currentRequest.follow_up_consult;
                    this.remarks = currentRequest.remarks;
                    this.screenshots = currentRequest.screenshot_urls;
                } else {
                    this.hourlyRate = this.userHourlyRate;

                    // set client credit from expert client credit rate
                    this.clientHourlyCredit = parseFloat(this.currentUser.expert.expert_pay_info.client_credit);
                }
            });

            document.getElementById(this.modalId).addEventListener("hide.bs.modal", () => {
                this.resetForm();
            });

            return modal;
        },
        userHourlyRate() {
            return this.currentUser.expert.expert_pay_info.hourly_rate;
        },
        requestSent() {
            return includes(this.requestSentList, this.assignmentId);
        },
        requestSentList() {
            return this.paymentRequests.map(request => request.assignment_id);
        },
        requestPaidStatus() {
            const payStatus = this.currentRequest?.paid ?? false;
            return payStatus === 1;
        },
        requestBtnTxt() {
            const payStatus = this.currentRequest?.paid ?? null;
            if (payStatus === 1) {
                return "Payment Paid";
            }
            return this.requestSent ? "Payment Requested" : "Request Payment";
        },

        currentRequest() {
            return this.getCurrentRequest();
        },
        hasCurrentRequest() {
            return this.currentRequest !== undefined && !isEmpty(this.currentRequest);
        },
        currentRequestLogs() {
            return this.currentRequest?.update_logs ?? [];
        },
        lastUpdatedStaff() {
            const logs = this.currentRequestLogs;
            return logs[0];
        },
        currentUser() {
            return this.userByEmail(this.expertUser.email);
        },
        completedStatusId() {
            return this.assignmentStatuses.find(status => status.name === "Completed").id;
        },
        clientHourlyCreditInput: {
            get() {
                return this.clientHourlyCredit.toFixed(2);
            },
            set(value) {
                this.clientHourlyCredit = value;
            },
        },
        ...mapGetters("project/payment", {
            paymentRequests: "requestSentList",
        }),
        ...mapGetters("expert", {
            userByEmail: "userByEmail",
        }),
    },
    methods: {
        async checkForm(e) {
            e.preventDefault();

            if (!this.isHeadHunting) {
                if (!includes(this.errors, "consultation-duration") && this.consultationDuration === null) {
                    this.errors.push("consultation-duration");
                    return false;
                } else {
                    this.errors.splice(this.errors.indexOf("consultation-duration"), 1);
                }


                if (!includes(this.errors, "hourly-rate") && this.hourlyRate === null) {
                    this.errors.push("hourly-rate");
                    return false;
                } else {
                    this.errors.splice(this.errors.indexOf("hourly-rate"), 1);
                }

                if (!includes(this.errors, "client-consultation-duration") && this.clientDuration === null) {
                    this.errors.push("client-consultation-duration");
                    return false;
                } else {
                    this.errors.splice(this.errors.indexOf("client-consultation-duration"), 1);
                }

                if (!includes(this.errors, "client-hourly-rate") && this.clientHourlyRate === null) {
                    this.errors.push("client-hourly-rate");
                    return false;
                } else {
                    this.errors.splice(this.errors.indexOf("client-hourly-rate"), 1);
                }

                if (this.in48Hours && this.$refs.file.files.length === 0) {
                    alert("Please upload screenshot");
                    return false;
                }
            } else {
                if (!includes(this.errors, "credits") && this.credits === null) {
                    this.errors.push("credits");
                    return false;
                } else {
                    this.errors.splice(this.errors.indexOf("credits"), 1);
                }
            }

            const requestId = this.hasCurrentRequest ? this.currentRequest.id : "";
            const formData = new FormData(this.$refs.form);
            formData.append("assignment_id", this.assignmentId.toString());
            formData.append("staff_user_id", this.staffUser.id);
            formData.append("request_id", requestId);
            await this.sendRequest(this.project.id, formData);
        },
        getCurrentRequest() {
            return this.$store.getters["project/payment/requestByAssignmentId"](this.assignmentId);
        },
        sendRequest(projectId, formData) {
            this.requesting = true;

            this.$store.dispatch(`project/payment/sendRequest`,
                {
                    projectId: projectId,
                    formData: formData,
                })
                .then(async () => {
                    await this.fetchRequests(this.project.id);
                    await this.$store.dispatch("expert/getProjectExperts", { projectId: this.project.id });

                    if (this.currentStatus !== "Completed") { //update expert status to completed
                        await this.$store.commit("expert/updateAssigmentStatus", {
                            statusName: "Completed",
                            statusId: this.completedStatusId,
                            projectId: this.project.id,
                            expertId: this.expertUser.expert.id,
                            assignmentId: this.assignmentId,
                        });
                    }

                    alert("Payment request sent");
                }).catch(error => {
                alert("Payment request failed");
                console.log(error);
            }).finally(() => {
                this.modal.hide();
            });
        },
        fetchRequests(projectId) {
            return this.$store.dispatch(`project/payment/getRequestSentList`, {
                projectId: projectId,
            });
        },
        selectImage() {
            this.currentImage = this.$refs.file.files.item(0);
            this.previewImage = URL.createObjectURL(this.currentImage);
            this.progress = 0;
            this.message = "";
        },
        resetForm() {
            if (!this.$refs.form) return;
            this.$refs.form.reset();

            if (this.$refs.file !== undefined) {
                this.$refs.file.value = "";
            }
            this.isHeadHunting = false;
            this.credits = null;
            this.consultationDuration = null;
            this.hourlyRate = null;
            this.clientDuration = null;
            this.clientHourlyRate = null;
            this.clientRateCurrency = "USD";
            this.in48Hours = false;
            this.followUp = false;
            this.currentImage = null;
            this.errors = [];

            this.requesting = false;
        },
    },
};
</script>

<style scoped>

</style>
